import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import { Dropdown } from 'components/Dropdown/Dropdown';

import HomeownerManual from 'Lots/Containers/home-hub-home-documents';
import HomeInventoryLot from 'Lots/Containers/home-hub-home-inventory';
import HomeMaintenance from 'Lots/Containers/home-hub-home-maintenance';

import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import * as AuthActionType from '../../Auth/constants';

import * as LotActionType from '../constants';
import { AppSettings } from '../../constants';

class HomeHub extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    homeownerLotSelectList: PropTypes.array,
    homeownerDocumentTypes: PropTypes.array,
    location: PropTypes.any,
    history: PropTypes.any,
    hobrand:PropTypes.array,
  };

  constructor(props) {
    super(props);

    this.queryParams = queryString.parse(location.search);
    this.lotId = this.queryParams.lotId;

    this.state = {
      activeKey: '1',
      lot: null
    };
  }

  componentDidMount() {
    this.fetchLot();
    this.getHOBranding();
  }

  getHOBranding=()=>{
    if(this.props.hobrand.length>0){
    let data = this.props.hobrand;
    var customStyleJson = JSON.parse(data[0].customStyleJson);
    var primaryPalette =  customStyleJson?customStyleJson.PrimaryPalette:'#4267b2';
    var secondaryPalette = customStyleJson?customStyleJson.SecondaryPalette:"#f06424";
    var hologo = data.length > 0 && 
    data[0].hoLogoUrl;
    document.body.style.setProperty(
      '--primary-color',
      primaryPalette
    );

    document.body.style.setProperty(
      '--secondary-color',
      secondaryPalette
    );
    if (hologo) {
      return (
        <img
          className='logo'
          src={hologo}
        />
      );
    } else {
      return ( <img
        className='logo'
        src={AppSettings.LOGO_30}
      />);
    }
  }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.homeownerLotSelectList.length && !this.state.lot) {
      if (this.lotId) {
        let currentLot = this.props.homeownerLotSelectList.find(l => l.value === this.lotId);

        if (currentLot) {
          this.setState({lot: currentLot});
        }

        this.removeQueryParam('lotId');
      }
      else
      {
        this.setState({
          lot: nextProps.homeownerLotSelectList[0]
        });}
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const prevLot = prevState.lot;
    const currentLot = this.state.lot;
    if (
      (!prevLot && currentLot) ||
      (prevLot && currentLot && prevLot.value !== currentLot.value)
    ) {
      this.fetchListDocumentType();
      this.setState({ activeKey: '1' });
    }
  };

  removeQueryParam = (...params) => {
    let queryParams = queryString.parse(location.search);

    params.forEach(key => delete queryParams[key]);
    this.props.history.push({
      pathname: location.pathname,
      search: queryString.stringify(queryParams)
    });
  }

  fetchListDocumentType = () => {
    const { lot } = this.state;

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_LIST_HOMEOWNER_DOCUMENT_TYPE_ASYNC,
      params: {
        endpoint: builderProfile.lotSharedDocumentTypesEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        lotId: lot.value
      }
    });
  };

  fetchLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC
    });
  };

  onSelectLot = event => {
    this.setState({
      lot: event.value
    });
  };

  onTabChange = (tab) => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);
    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        ...queryParams,
        tab: tab
      })
    });
  }

  render() {
    const { homeownerLotSelectList } = this.props;
    const queryParams = queryString.parse(location.search);
    const { lot } = this.state;
    if (lot) {
      return (
        <div id='manage-homeowner-manual' style={{margin: AppSettings.clientTypeValue === 'Homeowner'? '20px' : ''}}>
          <div className='page-title clearfix'>
            <h2 className='pull-left'>Home Hub</h2>
            <div className='select-lot'>
              <Dropdown
                onChange={this.onSelectLot}
                filter={true}
                className='filestring-dropdown filter-dropdown'
                options={homeownerLotSelectList}
                optionLabel='text'
                onRemote={this.fetchLot}
                value={lot}
                name='lot'
                placeholder='-- Please select'
                style={{ width: 300, marginLeft: 15, display: 'inline-block' }}
              />
            </div>
          </div>

          <div className='box-form-siteone container-fluid'>
            <Tab.Container
              id='project-tab'
              defaultActiveKey='home-documents'
              activeKey={queryParams.tab}
              onSelect={this.onTabChange}
            >
              <Row className='clearfix'>
                <Col sm={12}>
                  <Nav bsStyle='tabs'>
                    <NavItem eventKey='home-documents'>Home Documents</NavItem>
                    <NavItem eventKey='home-inventory'>Home Inventory</NavItem>
                    <NavItem eventKey='home-maintenance'>Home Maintenance</NavItem>
                  </Nav>
                </Col>
                <Col sm={12}>
                  <Tab.Content>
                    <Tab.Pane mountOnEnter={true} unmountOnExit={true} eventKey='home-documents'>
                      <HomeownerManual lot={lot} />
                    </Tab.Pane>
                    <Tab.Pane mountOnEnter={true} unmountOnExit={true} eventKey='home-inventory'>
                      <HomeInventoryLot lot={lot} />
                    </Tab.Pane>
                    <Tab.Pane mountOnEnter={true} unmountOnExit={true} eventKey='home-maintenance'>
                      <HomeMaintenance lot={lot} />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
    homeownerDocumentTypes: state.LotStore.HomeownerDocumentTypes,
    hobrand:state.authReducer.hobrand,
  };
};

export default withRouter(connect(mapStateToProps)(HomeHub));



// WEBPACK FOOTER //
// ./src/Lots/Containers/home-hub.js